import styled from "styled-components";
import { RichText } from "../../components/RichText";
import { mixinSkins } from "../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../skins/types";
import { riotProductSkin } from "./skins/riot-product";
export const RichTextSmall = styled(RichText) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=index.js.map